import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import i18n from 'modules/core/lib/i18n'

import GeneralBlock from 'modules/employees/components/blocks/General/GeneralBlock'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  isCurrent: boolean
  readonly?: boolean
}

const General = ({ employee, isCurrent, readonly }: Props) => {
  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="user"
        title={i18n.t('employee_form.general_information.title')}
        description={i18n.tCurrent('employee_form.general_information.description', isCurrent)}
      />
      <GeneralBlock employee={employee} readonly={readonly} />
    </PanesPadForm>
  )
}

export default observer(General)
